import {useMutation, useQuery} from "@tanstack/react-query";
import {sendResponseInvitation, getInvite} from "api/invitaionApi";
import {queryKeys} from "react-query/constant";
import {invitationStatus} from "../components/Invitation/Invitations";

export const useGetInvite = (id,setRequestStatus) => {
    return useQuery([queryKeys.getInvite], () => getInvite(id),
        {
            onSuccess:res=>console.log(res),
            onError: (err) => {
                console.log(err.response)
                if (err.response.status===404)
                    setRequestStatus(invitationStatus.INVITATION_ERROR)
            }
        }
    )
}
export const useSendResponse = () => {
    return useMutation({
        mutationFn: sendResponseInvitation,
        onSuccess: (res, args) => {
            const {setRequestStatus, isAccepted} = args
            console.log(isAccepted)
            console.log(isAccepted?invitationStatus.INVITATION_ACCEPTED:invitationStatus.INVITATION_REJECTED)
            setRequestStatus(isAccepted?invitationStatus.INVITATION_ACCEPTED:invitationStatus.INVITATION_REJECTED)
        }, onError: err => {
            console.log(err.response)
        }
    })
}